import { isObject } from './isObject';

export const isOfferADeal = (offer: IOrderDiscount): boolean => {
  return isObject(offer) && offer.promotion_type === 'deal';
};
